export enum MetaMenuType {
  USER_ACCOUNT = 1000,
  LANG,
  CURRENCY,
  CONTACT,
  CART,
  MANAGE_MY_TOOLS
}

export enum UserAccountMenuType {
  ACCOUNT_SELECT = 2000,
  USER_PROFILE,
  DOCUMENTS,
  TOOLS,
  FAVS
}

export enum PrimaryMenuType {
  EDITORIAL = 'EDITORIAL',
  PRODUCTS = 'PRODUCTS'
}

export enum ProductMenuType {
  CATEGORY = 'CATEGORY',
  TEASER = 'TEASER'
}

export type NavMenuType = MetaMenuType | PrimaryMenuType | ProductMenuType | UserAccountMenuType;
export const NavMenuType = { ...MetaMenuType, ...PrimaryMenuType, ...ProductMenuType, ...UserAccountMenuType };
